import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import {Breadcrumb, BreadcrumbItem  } from "react-bootstrap";
import { Link} from "react-router-dom";
import {RoutesLocal} from '../../routes';
import Preloader from "../../components/Preloader/Preloader";
import {Modal, ModalBody, ModalHeader, ModalFooter, Alert  } from "react-bootstrap";
import { Button, Dropdown, Table, ButtonGroup } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import ClientAccountsView from './ClientAccountsView';
import ClientOrdersView from './ClientOrdersView';

const config = require('../../config.json');

export default function AccountsExpiring() {
  const { validateLogin, alertClose , alertDetails, setAlertDetails, loggedUser} = useContext(ProductContext);
  const [loaded, setLoaded] = useState(false);
  const [clientViewCollapsed, setClientViewCollapsed] = useState(true);
  const [orderViewCollapsed, setOrderViewCollapsed] = useState(true);
  const [clientDetails, setClientDetails]= useState([]);
  const [selectedAccount, setSelectedAccount] = useState();

  useEffect(() => {
    alertClose();
    if(loggedUser.isAuthenticated){
        fetchExpiringAccounts();  
    }else{
        validateLogin();
    }
}, [loggedUser]);


    const fetchExpiringAccounts=async()=>{
       // console.log("fetching clients list");
        try{
          setLoaded(false);
          const { idToken } = (await fetchAuthSession()).tokens ?? {};
          await axios.get(`${config.api.invokeURL}/admin/clients/expiring-clients`,{
              headers: {
                Authorization: idToken,
                'x-api-key': config.api.key
              }}, 
          ).then((response)=>{
            console.log("Response : ", response);
              setClientDetails(response.data);
              setAlertDetails({
                  ...alertDetails,
                  style:"success",
                  open:true,
                  message: response.data.length + " - Records Found"
              });  
              //console.log(response);
              setLoaded(true);
          }).catch((error)=>{
              console.log(error);
              setAlertDetails({
                  ...alertDetails,
                  style:"warning",
                  open:true,
                  message:"Error Occured - " + error.message
              }); 
              setLoaded(true);
              //setDispMsg(error.message);
          })
        }catch(error){
          setAlertDetails({
            ...alertDetails,
            style:"warning",
            open:true,
            message:"Error Occured - " + error.message
        }); 
        setLoaded(true);
        }
    }

    const clientViewToggle=()=>{
      setClientViewCollapsed(!clientViewCollapsed);
    }

    const handleViewAccounts=async(event, item)=>{
        event.preventDefault();
        setSelectedAccount(item.client);
        clientViewToggle();
    }

    const orderViewToggle=()=>{
      setOrderViewCollapsed(!orderViewCollapsed);
    }

    const handleViewOrders=async(event, item)=>{
      event.preventDefault();
      setSelectedAccount(item.client);
      clientViewToggle();
  }

const handleEmailResend=async(event, item)=>{
  event.preventDefault();
  //setSelectedAccount(item);
  try{
    setLoaded(false);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
    await axios.get(`${config.api.invokeURL}/admin/clients/expiring-clients/email-trigger?clientOrg=${item.client.clientOrg}&clientId=${item.client.clientId}&validTo=${item.client.validTo}&packageName=${item.accounts.packageName}&clientPOC=${item.client.clientPOC}&discountValue=${item.client.discountValue}&couponCode=${item.client.couponCode}&clientEmail=${item.client.clientEmail}`,{
        headers: {
          Authorization: idToken,
          'x-api-key': config.api.key
        }}, 
    ).then((response)=>{
      //console.log("Response : ", response);
       // setClientDetails(response.data);
        setAlertDetails({
            ...alertDetails,
            style:"success",
            open:true,
            message: "Email Notification Sent Successfully!"
        });  
        //console.log(response);
        setLoaded(true);
    }).catch((error)=>{
        //console.log(error);
        setAlertDetails({
            ...alertDetails,
            style:"warning",
            open:true,
            message:"Error Occured - " + error.message
        }); 
        setLoaded(true);
        //setDispMsg(error.message);
    })
  }catch(error){
    setAlertDetails({
      ...alertDetails,
      style:"warning",
      open:true,
      message:"Error Occured - " + error.message
  }); 
  setLoaded(true);
  }
}
    
  return (
    <> 
        <main id="main" className="main">
    <Preloader show={loaded ? false : true} />
    <Breadcrumb>
    <BreadcrumbItem>
      <Link to={RoutesLocal.Presentation.path}>
        Home
      </Link>
    </BreadcrumbItem>
    <BreadcrumbItem >
      Expiring Accounts
    </BreadcrumbItem>
  </Breadcrumb>

        <Alert color={alertDetails.style} isOpen={alertDetails.open} toggle={alertClose} >
        {alertDetails.message}
        </Alert>
          {/*View Accounts*/}
        <Modal onHide={clientViewToggle} show={!clientViewCollapsed} style={{top:'10%', maxWidth:'800px'}}>
                    <Modal.Header toggle={clientViewToggle}>
                      Accounts
                    </Modal.Header>
                    <Modal.Body>    
                    <div>
                      <ClientAccountsView selectedAccount={selectedAccount}/>                        
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
            {' '}
            <Button onClick={clientViewToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
         {/*View Orders*/}
        <Modal onHide={orderViewToggle} show={!orderViewCollapsed} style={{top:'10%', maxWidth:'800px'}}>
          <Modal.Header toggle={orderViewToggle}>
            Accounts
          </Modal.Header>
          <Modal.Body>    
          <div>
                  <ClientOrdersView selectedAccount={selectedAccount}/>                        
            </div>
          </Modal.Body>
          <Modal.Footer>
            {' '}
            <Button onClick={orderViewToggle}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

        <Table responsive hover className="user-table align-items-center">
             <thead>
                <tr>
                <th>#</th>
                <th>Client ID</th>
                <th>Organisation</th>
                <th>Registered Date</th>
                <th>package Name</th>
                <th>Expiring Date</th>
                <th>Action</th>
                </tr>
            </thead>
            <tbody>
            {clientDetails.map((item, index)=>
            <tr key={index}>
            <th scope="row">{index+1}</th>
            <td>{item.client.clientId}</td>
            <td>{item.client.clientOrg}</td>
            <td>{item.client.clientRegisteredDate}</td>
            <td>{item.accounts.packageName}</td>
            <td>{item.accounts.validTo}</td>

           <td>
           <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <i className="bi bi-three-dots"></i>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
            <Dropdown.Item  onClick={(event)=>{handleEmailResend(event, item)}} >
                <i className="bi bi-envelope-at-fill"></i>  Resend Email
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleViewAccounts(event, item)}} >
                <i class="bi bi-eye"></i> View Accounts
              </Dropdown.Item>
              <Dropdown.Item  onClick={(event)=>{handleViewOrders(event, item)}} >
                <i class="bi bi-eye"></i> View Orders
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
            </td>
            </tr>)}
            </tbody>
        </Table>

       {clientDetails.length>0? <h6>Note: Above accounts are expiring in next 90 days.</h6>:
       <h6>Note: No Accounts expiring in next 90 days.</h6>}
       </main>
    </>
    )
}
